<template>
  <!--googleoff: noindex-->
  <p class="warning" :class="{ visible: isDev }">Error: {{ message }}</p>
  <!--googleon: noindex-->
</template>

<script setup lang="ts">
const isDev = ref<boolean>(false);

interface IProps {
  name?: string;
  _index?: number;
  staticData?: never;
  message?: string;
}

const props = withDefaults(defineProps<IProps>(), {
  name: undefined,
  _index: 0,
  staticData: undefined,
  message: 'Component not found.',
});

console.error('Error:', props.message);

onMounted(() => {
  isDev.value = import.meta.dev;
});
</script>

<style scoped lang="postcss">
.warning {
  display: none;
  visibility: hidden;
}
.visible {
  display: block !important;
  visibility: visible !important;
  color: red;
}
</style>
